import React from "react";
import { LuMail, LuMessageCircleMore } from "react-icons/lu";
import OttoMarkIcon from "../../../../icons/js/OttoMarkIcon";
import { AUDIT_LOG_ICON } from "./constants";

/**
 * The 16px glyph for an audit category — Lucide chat/mail plus the Otto brand
 * mark — shared by the Audit log drawer and the in-thread consent pill so the
 * two surfaces draw the same icon for the same event.
 */
const AuditLogIcon = ({ icon, color, size = 16 }) => {
  if (icon === AUDIT_LOG_ICON.CHAT) return <LuMessageCircleMore size={size} color={color} />;
  if (icon === AUDIT_LOG_ICON.MAIL) return <LuMail size={size} color={color} />;
  return <OttoMarkIcon width={size} height={size} color={color} />;
};

export default AuditLogIcon;
